import React, { useRef, useEffect, useState } from "react";
import { gsap } from "gsap";

const FadeInAnimation = ({
  children,
  wrapperElement = "div",
  direction = null,
  delay = 0,
  ...props
}) => {
  const Component = wrapperElement;
  const compRef = useRef(null);
  const [isInView, setIsInView] = useState(false);
  const distance = 200;

  let fadeDirection;
  switch (direction) {
    case "left":
      fadeDirection = { x: -distance };
      break;
    case "right":
      fadeDirection = { x: distance };
      break;
    case "up":
      fadeDirection = { y: distance };
      break;
    case "down":
      fadeDirection = { y: -distance };
      break;
    default:
      fadeDirection = { x: 0, y: 0 };
  }

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
        }
      },
      { threshold: 0.1 } // Trigger when 10% of the element is in view
    );

    if (compRef.current) {
      observer.observe(compRef.current);
    }

    return () => {
      if (compRef.current) {
        observer.unobserve(compRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (isInView) {
      gsap.fromTo(
        compRef.current,
        { ...fadeDirection, opacity: 0, visibility: "hidden" },
        { x: 0, y: 0, opacity: 1, visibility: "visible", duration: 1, delay }
      );
    }
  }, [isInView, fadeDirection, delay]);

  return (
    <Component
      ref={compRef}
      {...props}
      style={{
        visibility: "hidden", // Ensure the component is hidden initially
      }}
    >
      {children}
    </Component>
  );
};

export default FadeInAnimation;
